import { action } from 'typesafe-actions';
import { UserTypes } from './types';

export const changeUser = (name: string, phone: string, goal: number, currency: string, stopWin: number, stopLoss: number) =>
  action(UserTypes.USER_CHANGE, { name, phone, goal, currency, stopWin, stopLoss });

export const updateInstrumentsRequest = (instruments: any[]) =>
  action(UserTypes.UPDATE_INSTRUMENTS_REQUEST, { instruments });

export const updateInstrumentsSuccess = (instruments: any[]) =>
  action(UserTypes.UPDATE_INSTRUMENTS_SUCCESS, { instruments });

export const updateInstrumentsFailure = () =>
  action(UserTypes.UPDATE_INSTRUMENTS_FAILURE);

export const updateAssetsRequest = (assets: any[]) =>
  action(UserTypes.UPDATE_ASSETS_REQUEST, { assets });

export const updateAssetsSuccess = (assets: any[]) =>
  action(UserTypes.UPDATE_ASSETS_SUCCESS, { assets });

export const updateAssetsFailure = () =>
  action(UserTypes.UPDATE_ASSETS_FAILURE);

export const completeTour = () =>
  action(UserTypes.COMPLETE_TOUR);

export const loadDemoData = () =>
  action(UserTypes.LOAD_DEMO_DATA);

export const clearDemoData = () =>
  action(UserTypes.CLEAR_DEMO_DATA);

export const updateTagsRequest = (tags: string[]) =>
  action(UserTypes.UPDATE_TAGS_REQUEST, { tags });

export const updateTagsSuccess = (tags: string[]) =>
  action(UserTypes.UPDATE_TAGS_SUCCESS, { tags });

export const updateTagsFailure = () =>
  action(UserTypes.UPDATE_TAGS_FAILURE);
